(function () {


   try {
      let placeholderText = 'Search buy.hpe.com';
      const BODY_SELECTOR = 'fe-hpe-4065';

      /** Set only once the bar is in the DOM — gates every CSS rule that hides
          native HFWS search chrome, so a failed mount leaves the page untouched. */
      const MOUNTED_BODY_SELECTOR = 'fe-4065-search-mounted';

      /** Mirrors the breakpoint in 4065a.css. Below it the inline bar is hidden and
          HPE's own search takes over, so nothing here may touch native search chrome. */
      const INLINE_BAR_QUERY = '(min-width: 600px)';

      const SelectorsDictionary = {
         SearchFlyout: 'div#hpehf-search-flyout',
         SearchFlyoutArea: '.hpehf-search-flyout-area',
         SearchInput: 'input#hpehf-search-input',
         SearchSubmitButton: 'a#hpehf-search-submit',
         SearchForm: 'form.hpehf-search-form',
         SearchAutocomplete: 'div#hpehf-search-autocomplete',
         SearchIconTrigger: 'li#hpehf-search',
         SearchIconLink: 'li#hpehf-search a.hpehf-nav-link',
         SecondaryNavContent: 'div#hpehf-secondary-nav > div.hpehf-centered-content',
         SecondaryNavSection: 'div#hpehf-secondary-nav-section',
      };

      /**
       * Resolves the mount point: the left edge of the secondary store nav, ahead
       * of the Shop section. There is no alternate placement — if HFWS renders a
       * page without a secondary nav the bar is not built at all, and the page
       * keeps its native search untouched. `waitForConditions` cannot gate on the
       * nav because an unmet condition silently drops the whole variant.
       *
       * @returns {{parent: Element, before: Node|null}|null}
       */
      function resolveMountPoint() {
         const secondaryNavContent = document.querySelector(SelectorsDictionary.SecondaryNavContent);
         if (!secondaryNavContent) return null;

         return {
            parent: secondaryNavContent,
            before: secondaryNavContent.querySelector(SelectorsDictionary.SecondaryNavSection),
         };
      }

      /**
       * Creates an inline search bar in the secondary store nav and wires
       * input/submit events to the existing HFWS search infrastructure.
       */
      function createInlineSearch() {
         const mountPoint = resolveMountPoint();
         const realSearchInput = document.querySelector(SelectorsDictionary.SearchInput);
         const realSearchForm = document.querySelector(SelectorsDictionary.SearchForm);
         const realSubmitButton = document.querySelector(SelectorsDictionary.SearchSubmitButton);

         if (!mountPoint || !realSearchInput || !realSearchForm) return;

         /** Pull placeholder from the existing search input to support all languages */
         // if (realSearchInput.placeholder) {
         //    placeholderText = realSearchInput.placeholder;
         // }

         /** Build wrapper element */
         const wrapper = document.createElement('div');
         wrapper.id = 'fe-4065-search-wrapper';

         /** Build search input */
         const input = document.createElement('input');
         input.type = 'search';
         input.id = 'fe-4065-search-input';
         input.placeholder = placeholderText;
         input.autocomplete = 'off';
         input.spellcheck = false;
         input.setAttribute('aria-label', 'Search buy.hpe.com');

         /** Build submit button — reuse the HFWS magnifying glass SVG */
         const btn = document.createElement('button');
         btn.type = 'button';
         btn.id = 'fe-4065-search-btn';
         btn.setAttribute('aria-label', 'Search');
         if (realSubmitButton) {
            btn.innerHTML = realSubmitButton.innerHTML;
         }
         const wrapperInner = document.createElement('div');
         wrapperInner.id = 'fe-4065-search-wrapper-inner';
         wrapperInner.appendChild(input);
         wrapperInner.appendChild(btn);
         wrapper.appendChild(wrapperInner);
         mountPoint.parent.insertBefore(wrapper, mountPoint.before);
         document.body.classList.add(MOUNTED_BODY_SELECTOR);

         /** Class applied to the currently arrow-key-highlighted suggestion row.
             Owned entirely by this file — HFWS's own highlight/dismiss logic keys
             off real DOM focus, which the proxy input never has, so suggestion
             navigation is reimplemented here instead of relying on synthetic
             events reaching HFWS's native handler. */
         const SUGGESTION_ACTIVE_CLASS = 'fe-4065-suggestion-active';
         const SUGGESTION_ITEM_SELECTOR = '.hpehf-centered-content';

         let suggestionItems = [];
         let selectedSuggestionIndex = -1;

         function resetSuggestionHighlight() {
            suggestionItems.forEach(function (item) {
               item.classList.remove(SUGGESTION_ACTIVE_CLASS);
            });
            suggestionItems = [];
            selectedSuggestionIndex = -1;
         }

         /**
          * The query string a suggestion row stands for. HFWS parks it in a hidden
          * input alongside the visible label, which is the reliable source — the
          * label carries markup for the matched-prefix bolding.
          *
          * @param {Element} item A suggestion row.
          * @returns {string}
          */
         function suggestionQuery(item) {
            const hidden = item.querySelector('input[type="hidden"]');
            return (hidden && hidden.value) || item.textContent.trim();
         }

         function highlightSuggestion(nextIndex) {
            const autocomplete = document.querySelector(SelectorsDictionary.SearchAutocomplete);
            suggestionItems = autocomplete
               ? Array.from(autocomplete.querySelectorAll(SUGGESTION_ITEM_SELECTOR))
               : [];

            suggestionItems.forEach(function (item) {
               item.classList.remove(SUGGESTION_ACTIVE_CLASS);
            });

            if (!suggestionItems.length) {
               selectedSuggestionIndex = -1;
               return;
            }

            selectedSuggestionIndex = ((nextIndex % suggestionItems.length) + suggestionItems.length) % suggestionItems.length;
            const active = suggestionItems[selectedSuggestionIndex];
            active.classList.add(SUGGESTION_ACTIVE_CLASS);
            active.scrollIntoView({ block: 'nearest' });
         }

         /**
          * Proxy typing to the real HFWS input so autocomplete populates.
          */
         input.addEventListener('input', function () {
            realSearchInput.value = input.value;
            realSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
            realSearchInput.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
            resetSuggestionHighlight();
         });

         /**
          * Proxy keyboard events for form submission and autocomplete navigation.
          */
         input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
               e.preventDefault();
               /** A highlighted suggestion wins — Enter selects it, rather than
                   re-submitting the raw typed text. HFWS wires suggestion
                   selection to a jQuery `mousedown` handler, not `click`, so
                   `.click()` is a silent no-op here; `mousedown` is what actually
                   triggers navigation. */
               if (selectedSuggestionIndex > -1 && suggestionItems[selectedSuggestionIndex]) {
                  const selected = suggestionItems[selectedSuggestionIndex];
                  /** Navigation takes a second or two. Show the chosen query in the
                      field first so it is clear which search is running. */
                  input.value = suggestionQuery(selected);
                  realSearchInput.value = input.value;
                  selected.dispatchEvent(new MouseEvent('mousedown', {
                     bubbles: true,
                     cancelable: true,
                  }));
                  return;
               }
               realSearchInput.value = input.value;
               realSearchForm.submit();
            } else if (e.key === 'ArrowDown') {
               e.preventDefault();
               highlightSuggestion(selectedSuggestionIndex + 1);
            } else if (e.key === 'ArrowUp') {
               e.preventDefault();
               highlightSuggestion(selectedSuggestionIndex - 1);
            } else if (e.key === 'Escape') {
               e.preventDefault();
               resetSuggestionHighlight();
               const autocomplete = document.querySelector(SelectorsDictionary.SearchAutocomplete);
               if (autocomplete) autocomplete.style.display = 'none';
            }
         });

         /** Submit search on button click */
         btn.addEventListener('click', function () {
            if (input.value.trim()) {
               realSearchInput.value = input.value;
               realSearchForm.submit();
            } else {
               input.focus();
            }
         });

         const autocomplete = document.querySelector(SelectorsDictionary.SearchAutocomplete);

         if (autocomplete) {
            /** Sync value back when user clicks an autocomplete suggestion */
            autocomplete.addEventListener('click', function () {
               resetSuggestionHighlight();
               setTimeout(function () {
                  input.value = realSearchInput.value;
               }, 150);
            });
         }

         /** Where HFWS parks the autocomplete, recorded before it is ever moved so
             the mobile layout can be handed back exactly as it was found. */
         const autocompleteHome = autocomplete && autocomplete.parentNode;
         const autocompleteNextSibling = autocomplete && autocomplete.nextSibling;
         const flyout = document.querySelector(SelectorsDictionary.SearchFlyout);

         /**
          * Applies the two DOM-level changes the inline bar needs, and undoes them
          * below the breakpoint. Both are destructive to HPE's own mobile search,
          * which renders from inside the flyout at the top of the hamburger menu:
          *
          *   - the flyout is hidden with inline styles, which no media query in
          *     4065a.css can scope, so mobile lost its search row entirely
          *   - the autocomplete is reparented into the inline wrapper, which is
          *     `display: none` below the breakpoint, so suggestions had nowhere to go
          *
          * @param {boolean} inlineBarVisible Whether the inline bar is the active search UI.
          */
         function applyBreakpointState(inlineBarVisible) {
            if (flyout) {
               flyout.style.visibility = inlineBarVisible ? 'hidden' : '';
               flyout.style.height = inlineBarVisible ? '0' : '';
               flyout.style.overflow = inlineBarVisible ? 'hidden' : '';
            }

            if (!autocomplete) return;

            if (inlineBarVisible) {
               /** Move it into the inline wrapper so it escapes the hidden flyout */
               wrapper.appendChild(autocomplete);
            } else if (autocompleteHome) {
               autocompleteHome.insertBefore(autocomplete, autocompleteNextSibling);
            }
         }

         const inlineBarMedia = window.matchMedia(INLINE_BAR_QUERY);
         applyBreakpointState(inlineBarMedia.matches);

         /** Resizing across the breakpoint (rotation, desktop window drag) has to
             swap which search UI owns the flyout and the autocomplete. */
         inlineBarMedia.addEventListener('change', function (event) {
            applyBreakpointState(event.matches);
         });

         /** Pre-fill from the `text` query parameter if present */
         // const prefillText = feReusable.getQueryParam('text');
         // if (prefillText) {
         //    input.value = prefillText;
         //    realSearchInput.value = prefillText;
         // }

      }

      /**
       * Initialises the variant: adds body selector and creates inline search.
       */
      function init() {
         document.body.classList.add(BODY_SELECTOR);
         createInlineSearch();
      }

      window.feUtils.waitForConditions({
         conditions: [
            SelectorsDictionary.SearchInput,
            SelectorsDictionary.SecondaryNavContent,
         ],
         activity: feProjectId,
         callback: init,
      });
   } catch (err) {
      window.feHPEB2C?.log('FE:4065 error:', err);
   }
})();
